<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4">
        <h6>Recipient List</h6>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table>
          <template v-slot: default>
            <tbody>
              <tr v-for="(email, position) in emailList" :key="position">
                <td>
                  <b-link @click="editEmail(position)">
                    <v-icon size="15">edit</v-icon>
                    {{ email }}
                  </b-link>
                </td>
                <td>
                  <b-link @click="deleteEmail(position)">
                    <v-icon color="red darken-1">delete</v-icon>
                  </b-link>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    emailList: Array,
    loading: Boolean
  },
  computed: {},
  methods: {
    editEmail(position) {
      this.$emit("eEditEmail", position);
    },
    deleteEmail(position) {
      this.emailList.splice(position, 1);
    }
  }
};
</script>
